export default __webpack_public_path__ + "static/media/easyquant.2afc1fb9.svg";